import { useMemo } from 'react'

import { PhantomTypeArgument, TypeArgument } from '@/shared/gen/_framework/reified'
import { PositionConfigInfo } from '@kunalabs-io/kai'
import { useObjectBcs } from '@/shared/hooks/batshitObjectFetcher'

export const useConfigData = (
  configInfo: PositionConfigInfo<PhantomTypeArgument, PhantomTypeArgument, TypeArgument>
) => {
  const configBcsQuery = useObjectBcs(configInfo.configId)
  const poolBcsQuery = useObjectBcs(configInfo.poolObjectId)
  const supplyPoolXQuery = useObjectBcs(configInfo.supplyPoolXInfo.id)
  const supplyPoolYQuery = useObjectBcs(configInfo.supplyPoolYInfo.id)

  const config = useMemo(() => {
    if (!configBcsQuery.data) {
      return undefined
    }
    return configInfo.configFromBcs(configBcsQuery.data)
  }, [configBcsQuery.data, configInfo])

  const pool = useMemo(() => {
    if (!poolBcsQuery.data) {
      return undefined
    }
    return configInfo.poolFromBcs(poolBcsQuery.data)
  }, [poolBcsQuery.data, configInfo])

  const supplyPoolX = useMemo(() => {
    if (!supplyPoolXQuery.data) {
      return undefined
    }
    return configInfo.supplyPoolXInfo.fromBcs(supplyPoolXQuery.data)
  }, [supplyPoolXQuery.data, configInfo.supplyPoolXInfo])

  const supplyPoolY = useMemo(() => {
    if (!supplyPoolYQuery.data) {
      return undefined
    }
    return configInfo.supplyPoolYInfo.fromBcs(supplyPoolYQuery.data)
  }, [supplyPoolYQuery.data, configInfo.supplyPoolYInfo])

  return { config, pool, supplyPoolX, supplyPoolY }
}
